module.exports = __webpack_public_path__ + "img/jumbopack-badge.cdf5036a.svg";